import { render } from "./Green.vue?vue&type=template&id=6af4748c&scoped=true&ts=true"
import script from "./Green.vue?vue&type=script&lang=ts"
export * from "./Green.vue?vue&type=script&lang=ts"

import "./Green.vue?vue&type=style&index=0&id=6af4748c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af4748c"]])

export default __exports__